<i
  #openuploadmonitor
  class="kIconfolder_large kUploadMonitorToggler"
  [class.kDisabled]="!_isAvailable"
  [class.upToDate]="_upToDate"
  [class.open]="_menuOpened"
  [kTooltip]="'app.titles.uploadMonitor' | translate"
  [placement]="'bottom'"
>
  <!--img *ngIf="!_upToDate && !_showErrorIcon" class="kIconrefresh_small" [src]="_syncUri"-->
  <i *ngIf="!_upToDate && !_showErrorIcon" class="kIconrefresh_small"></i>
  <i *ngIf="_showErrorIcon" class="kIconerror"></i>
</i>

<kPopupWidget
  #uploadmonitor
  class="uploadMonitorPopup"
  data-aid="uploadmonitor"
  [closeOnResize]="true"
  [appendTo]="appmenu"
  [popupWidth]="553"
  [popupHeight]="_popupHeight"
  [closeBtn]="false"
  [targetRef]="openuploadmonitor"
  [targetOffset]="{ x: -109, y: 37 }"
  (onOpen)="_onMonitorOpen()"
  (onClose)="_onMonitorClose()"
>
  <ng-template>
    <kUploadMonitorSection
      [detailsViewService]="_contentUploadsMainViewService"
      *ngIf="_isUploadAvailable"
      [uploadMonitorPopup]="uploadmonitor"
      [title]="'applications.upload.uploadMonitor.uploadFromDesktop' | translate"
      [uploading]="_uploadFromDesktop.uploading"
      [queued]="_uploadFromDesktop.queued"
      [completed]="_uploadFromDesktop.completed"
      [layout]="'totals'"
      [errors]="_uploadFromDesktop.errors"
    ></kUploadMonitorSection>
    <kUploadMonitorSection
      [detailsViewService]="_contentBulkUploadsMainViewService"
      *ngIf="_isBulkAvailable"
      [title]="'applications.upload.uploadMonitor.bulkUpload' | translate"
      [uploadMonitorPopup]="uploadmonitor"
      [uploading]="_bulkUpload.uploading"
      [queued]="_bulkUpload.queued"
      [completed]="_bulkUpload.completed"
      [errors]="_bulkUpload.errors"
      [layout]="_bulkUploadLayout"
      (requestToRecover)="_bulkTryReconnect()"
    ></kUploadMonitorSection>
    <kUploadMonitorSection
      *ngIf="_isDropFolderAvailable && _dropFoldersLayout"
      type="dropFolder"
      [detailsViewService]="_contentDropFoldersMainViewService"
      [title]="'applications.upload.uploadMonitor.dropFolders' | translate"
      [uploadMonitorPopup]="uploadmonitor"
      [uploading]="_dropFolders.uploading"
      [queued]="_dropFolders.queued"
      [completed]="_dropFolders.completed"
      [errors]="_dropFolders.errors"
      [layout]="_dropFoldersLayout"
      (requestToRecover)="_dropFoldersTryReconnect()"
    ></kUploadMonitorSection>
  </ng-template>
</kPopupWidget>
